import { AssessmentAnalysis, AssessmentAnalysisInterface } from 'app/assessment/models/index';
import { RecommendationInterface } from 'app/recommendation/models';

export interface EvaluationAnalysisInterface extends AssessmentAnalysisInterface {
  recommendations?: RecommendationInterface[];
}

export class EvaluationAnalysis extends AssessmentAnalysis implements EvaluationAnalysisInterface {

  public recommendations?: RecommendationInterface[];

  constructor({
    recommendations = undefined,
    }: EvaluationAnalysisInterface) {
    super(arguments[0]);
    this.recommendations = recommendations;
  }
}
